<template>
  <div class="layout" id="layout">
    <div class="video-box scroll-section">
      <video ref="video" src="../../public/video.mp4" controls autoplay muted />
      <div class="mask" v-if="isMask">
        <img src="@/assets/play.png" @click="videoPlay" />
      </div>
    </div>
    <div class="scroll-section">
      <container v-model="mouseInMap" :isMapPage="currentSection === 1"></container>
    </div>
  </div>
</template>

<script>
import container from "@/components/container.vue"
export default {
  name: 'layout',
  components: {
    container
  },
  data() {
    return {
      isMask: false,

      // 鼠标是否在地图上
      mouseInMap: false,
      currentSection: 0
    }
  },
  methods:{
    videoPlay(){
      this.$refs.video.play();
      this.isMask = false;
    },
    /*
      使用js实现滚动吸附
      百度地图有bug,用css实现滚动吸附会导致百度地图缩放无法在鼠标位置处缩放 没找到解决方案 高德地图没有这个bug
     */
    initScroll(){
      const items = document.querySelectorAll('.scroll-section');
      let currentIndex = 0;
      let isAnimating = false;

      // 获取所有可滚动元素
      const layout = document.querySelector('body');
      const getScrollables = () => {
        return Array.from(layout.querySelectorAll('*')).filter(el => {
          const style = getComputedStyle(el);
          return (
            (style.overflowY === 'auto' || style.overflowY === 'scroll') &&
            el.scrollHeight > el.clientHeight
          );
        });
      };

      // 实时检测函数（每次事件触发时都重新获取）
      const isInScrollable = (target) => {
        return getScrollables().some(el => el.contains(target));
      };

      document.addEventListener('wheel', (e) => {
        // 实时检测可滚动元素（包含新增元素）|| 监听鼠标移入地图
        if (isInScrollable(e.target) || this.mouseInMap) {
          e.stopPropagation();
          return;
        }

        if (isAnimating) return;

        const delta = Math.sign(e.deltaY);
        const newIndex = delta > 0
          ? Math.min(currentIndex + 1, items.length - 1)
          : Math.max(currentIndex - 1, 0);

        if (newIndex !== currentIndex) {
          isAnimating = true;
          currentIndex = newIndex;
          this.currentSection = currentIndex;

          window.scrollTo({
            top: items[currentIndex].offsetTop,
            behavior: 'smooth'
          });

          setTimeout(() => isAnimating = false, 200);
        }
      });



      /*// 双重监听方案
      const observer = new MutationObserver(() => {});
      observer.observe(layout, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });

      // 新增：使用ResizeObserver检测尺寸变化
      const resizeObserver = new ResizeObserver(() => {});
      resizeObserver.observe(layout, { subtree: true });*/
    }
  },
  mounted() {

    this.initScroll();

    window.scrollTo(0, 0)
  }
}
</script>

<style scoped lang="scss">
.layout{
  width: 100%;
  overflow-y: hidden;
  .header{
    height: 88px;
    width: 100%;
    background: #fff;
    font-weight: 800;
    font-size: 27px;
    color: #0E0E0E;
    display: flex;
    align-items: center;
    padding-left: 45px;
    img{
      width: 54px;
      height: 54px;
      margin-right: 5px;
    }
  }
  .video-box{
    position: relative;
    video{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .mask{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 78px;
        height: 78px;
        cursor: pointer;
      }
    }
  }
  .scroll-section{
    height: 100vh;
    width: 100%;
    scroll-snap-align: start;
  }
}
</style>
